import { render, staticRenderFns } from "./articleDetailType1.vue?vue&type=template&id=26fabe4c&scoped=true&"
import script from "./articleDetailType1.vue?vue&type=script&lang=ts&"
export * from "./articleDetailType1.vue?vue&type=script&lang=ts&"
import style0 from "./articleDetailType1.vue?vue&type=style&index=0&id=26fabe4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fabe4c",
  null
  
)

export default component.exports